import { useEffect, useState } from 'react';

import { trackMicPermission } from '../utils/segment';

const useMicPermission = () => {
  const [micPermissionStatus, setMicPermissionStatus] = useState('');
  const [trackMicPermissionPrompt, setTrackMicPermissionPrompt] = useState(false);

  useEffect(() => {
    let permissionResult;

    // Note that some browsers, most notably Safari and Firefox, still don't
    // fully support permissions API (and may never support it due to privacy concerns).
    // So this microphone check is more or less just informational, and is later used for
    // sending tracking information to Segment
    const { permissions } = window.navigator;

    if (permissions) {
      (async () => {
        try {
          permissionResult = await permissions.query({ name: 'microphone' });
          // 'onchange' fires when user grants/denies access,
          // only works reliably in Chrome and derivatives.
          permissionResult.onchange = () => {
            setMicPermissionStatus(permissionResult.state);
          };
          setMicPermissionStatus(permissionResult.state);
        } catch (err) {
          // Ignore any error, as permissions API is still draft/experimental API:
          // https://developer.mozilla.org/en-US/docs/Web/API/Navigator/permissions
        }
      })();
    }

    return () => {
      if (permissionResult) {
        // clear the callback on component unmount.
        permissionResult.onchange = null;
      }
    };
  }, []);

  useEffect(() => {
    if (trackMicPermissionPrompt) {
      trackMicPermission(micPermissionStatus);
      setTrackMicPermissionPrompt(false);
    }

    if (micPermissionStatus === 'prompt') {
      // track user's choice
      setTrackMicPermissionPrompt(true);
    }
  }, [micPermissionStatus]);

  return { micPermissionStatus, trackMicPermissionPrompt };
};

export default useMicPermission;
